export interface RadioStation {
  id: string;
  name: string;
  subtitle: string;
  /**
   * URL официального аудиопотока станции.
   *
   * Поддерживаются:
   *   - прямые MP3/AAC потоки (icecast / shoutcast) — играются нативно;
   *   - HLS-плейлисты `.m3u8` — Safari играет нативно, для Chrome/Firefox
   *     hls.js подгружается динамически.
   *
   * Перед обновлением — сверяйтесь с актуальным URL на сайте станции
   * или с присланной заказчиком ссылкой.
   */
  streamUrl: string;
}

export const radioStations: RadioStation[] = [
  {
    id: 'studio21',
    name: 'STUDIO 21',
    subtitle: 'Hip-hop radio',
    // Основной федеральный HLS-поток STUDIO 21, тот же что используется
    // официальным плеером на studio21.ru. Content-Type: audio/mpegurl.
    // В Chrome/Firefox/Edge играется через hls.js (lazy-load), в Safari
    // — нативно.
    //
    // Региональный поток для Екатеринбурга (если нужен):
    //   https://hls-01-regions.emgsound.ru/30_ekb/playlist.m3u8
    streamUrl: 'https://hls.studio21.ru/studio21/playlist.m3u8',
  },
  {
    id: 'shanson',
    name: 'Радио Шансон',
    subtitle: 'Музыка для души',
    // Прямой MP3-поток 256 kbps на инфраструктуре hostingradio.ru —
    // официальный публичный эфир «Радио Шансон». Content-Type: audio/mpeg.
    // Играется нативно во всех браузерах.
    streamUrl: 'https://chanson.hostingradio.ru:8041/chanson256.mp3',
  },
];

export const defaultStationId = 'studio21';
